import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiLayers, FiZap, FiTarget, FiTrendingUp, FiArrowRight } from '../common/Icons';

const Services = () => {
  const steps = [
    {
      title: "Sblocco Ecosistema",
      icon: FiLayers,
      tag: "STEP 01",
      desc: "Accesso immediato alla piattaforma Alpha."
    },
    {
      title: "Strumenti & Expertise",
      icon: FiZap,
      tag: "STEP 02",
      desc: "Download tool e setup con il nostro team."
    },
    {
      title: "Percorso & Avvio",
      icon: FiTarget,
      tag: "STEP 03",
      desc: "Scelta del modello e lancio operativo."
    },
    {
      title: "Monetizzazione",
      icon: FiTrendingUp,
      tag: "GOAL",
      desc: "Ottimizzazione dei margini e scaling."
    }
  ];

  return (
    <section id="services" className="py-24 bg-black-pure relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-4">
          <div className="max-w-xl">
            <h2 className="text-4xl md:text-6xl font-black text-white tracking-tighter uppercase">
              road<span className="text-orange-500 italic">map</span>
            </h2>
          </div>
          <p className="text-slate-500 font-bold uppercase text-xs tracking-[0.3em] border-l-2 border-orange-500 pl-4">
            Dall'idea alla scalabilità
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
          {steps.map((s, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              className="group relative bg-white/5 border border-white/10 p-8 rounded-[2rem] hover:bg-orange-500/5 hover:border-orange-500/30 transition-all duration-500"
            >
              <div className="flex flex-col h-full">
                <div className="flex justify-between items-start mb-12">
                  <div className="w-12 h-12 bg-orange-500/10 rounded-2xl flex items-center justify-center text-orange-500 group-hover:bg-orange-500 group-hover:text-white transition-all duration-500">
                    <SafeIcon icon={s.icon} className="w-6 h-6" />
                  </div>
                  <span className="text-[10px] font-black text-white/30 tracking-widest uppercase group-hover:text-orange-500 transition-colors">
                    {s.tag}
                  </span>
                </div>
                <h3 className="text-xl font-black text-white mb-3 leading-tight uppercase tracking-tight">{s.title}</h3>
                <p className="text-slate-500 text-sm font-medium leading-relaxed">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          className="flex justify-center"
        >
          <button 
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="btn-premium text-white px-12 py-5 rounded-2xl font-black text-xl flex items-center space-x-3 shadow-[0_0_50px_rgba(249,115,22,0.3)]"
          >
            <span>Parla con noi</span>
            <SafeIcon icon={FiArrowRight} />
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;